import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Announcement, AnnouncementType, SimpleAnnouncement } from "../models/announcement.model";

@Injectable({ providedIn: "root" })
export class AnnouncementsApiService {
    private http = inject(HttpClient);

    /**
     * Get all announcements
     * @returns {Array<SimpleAnnouncement>}
     */
    getAll(): Observable<Array<SimpleAnnouncement>> {
        return this.http.get<Array<SimpleAnnouncement>>(this.announcementsUrl());
    }

    /**
     * Get announcement by announcementId
     * @param announcementId
     */
    getById(announcementId: number): Observable<Announcement> {
        return this.http.get<Announcement>(`${this.announcementsUrl()}/${announcementId}`);
    }

    /**
     * Mark announcement as read
     * @param announcementID
     */
    markAsRead(announcementID: number): Observable<void> {
        return this.http.put<void>(`${this.announcementsUrl()}/seen/${announcementID}`, null);
    }

    /**
     * Mark all announcements as read
     */
    markAllAsRead(announcementIDs: number[]): Observable<void> {
        return this.http.put<void>(`${this.announcementsUrl()}/seen`, announcementIDs);
    }

    /**
     * Get announcement types
     */
    getAnnouncementTypes(): Observable<AnnouncementType[]> {
        return this.http.get<AnnouncementType[]>(`${this.announcementsUrl()}/types`);
    }

    private announcementsUrl(): string {
        return "/api/platform/announcements";
    }
}
